import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import IconButton from '@cotyorg/ccx-molecules/IconButton';

const FORWARD_DIRECTION = 'forward';
const BACKWARD_DIRECTION = 'backward';

const generateButtonClassNames = ({ isForward, showPagination }) => (
  classNames('carousel__button', {
    'carousel__button--backward': !isForward,
    'carousel__button--forward': isForward,
    'carousel__button--always-show': !showPagination,
  })
);

const getIconName = ({
  isForward,
  rightChevronIconSrc,
  leftChevronIconSrc,
}) => (
  isForward ? rightChevronIconSrc : leftChevronIconSrc
);

const onClick = ({
  setIndex,
  carouselsStoreDataKey,
  index,
  onIndexChange,
  currentIndex,
  isForward,
}) => {
  setIndex({ carouselsStoreDataKey, index });

  if (onIndexChange) {
    onIndexChange({
      type: 'CarouselButton',
      currentIndex,
      index,
      isForward,
    });
  }
};

const CarouselButton = ({
  carouselsStoreDataKey,
  direction,
  setIndex,
  nextItemText = 'Next Item',
  previousItemText = 'Previous Item',
  currentIndex,
  rightChevronIconSrc,
  leftChevronIconSrc,
  onIndexChange,
  showPagination,
  testAttribute,
}) => {
  const isForward = direction === FORWARD_DIRECTION;
  const index = isForward ? currentIndex + 1 : currentIndex - 1;

  return (
    <IconButton
      iconSrc={getIconName({ isForward, rightChevronIconSrc, leftChevronIconSrc })}
      size="small"
      extraClass={generateButtonClassNames({ isForward, showPagination })}
      testAttribute={testAttribute}
      onClick={() => onClick({
        setIndex,
        carouselsStoreDataKey,
        index,
        onIndexChange,
        currentIndex,
        isForward,
      })}
    >
      <span className="show-for-sr">{isForward ? nextItemText : previousItemText}</span>
    </IconButton>
  );
};

CarouselButton.propTypes = {
  carouselsStoreDataKey: PropTypes.string.isRequired,
  direction: PropTypes.oneOf([FORWARD_DIRECTION, BACKWARD_DIRECTION]).isRequired,
  setIndex: PropTypes.func.isRequired,
  nextItemText: PropTypes.string,
  previousItemText: PropTypes.string,
  currentIndex: PropTypes.number.isRequired,
  rightChevronIconSrc: PropTypes.string,
  leftChevronIconSrc: PropTypes.string,
  onIndexChange: PropTypes.func,
  showPagination: PropTypes.bool,
};

export default CarouselButton;
